import React from 'react';
import NavBar from '../../components/userHomeNavBar/navBar'
import SideBar from '../../components/userHomeSideBar/sideBar'
import OrganizerSection from '../../components/adminHome/Organizations Section/OrganizerSection';
import UsersSection from '../../components/adminHome/Users Section/UsersSection';
import HomeSection from '../../components/adminHome/Home Section/HomeSection';
import ProductsSection from '../../components/adminHome/Products Section/ProductsSection';
import LocalAuthoritiesSection from '../../components/adminHome/Local Authorities Section/LocalAuthoritiesSection';
import { Layout, Button, Card, Typography } from 'antd';

const { Content } = Layout;

const AdminHomePage = () => {
    return (
       
            <section >
            <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Admin Dashboard
                                <small>Welcome to enableSEND</small>
                            </h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item"><a href="index.html"><i className="zmdi zmdi-home"></i> Compass</a></li>
                                <li className="breadcrumb-item active">Admin Dashboard</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        {/* User Section */}
                        <div className="col-lg-6 col-md-8 col-sm-12">
                            <UsersSection />
                        </div>
                        <div className="col-lg-6 col-md-8 col-sm-12">
                            <LocalAuthoritiesSection />
                        </div>
                    </div>
                    {/* Organizer Section */}
                    <div className="col-lg-12 col-md-8 col-sm-12">
                        <OrganizerSection />
                    </div>
                 
                </div>
            </section>
                );
}

export default AdminHomePage;